// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__vZk1R","head":"Table_head__2otrI","col":"Table_col__PEfJ2"};